/**
 * Schaden melden — Inventar 2.0, S7b.
 *
 * Moved out of the page and put on the shared dialog chrome S7a introduced.
 * Presentation only: the three fields keep their order, their types and their
 * attributes (the description is the dialog's ONLY textbox and stays required,
 * the cost is its only spinbutton, the date input keeps type="date"), the
 * submit stays a real submit inside the <form>, and the payload, the guard and
 * the reload all remain in the page.
 *
 * The date is seeded by the page from todayBusinessDate() — Europe/Zurich, not
 * UTC (CLAUDE.md Regel 51). Nothing here recomputes it.
 *
 * No damage_status field, and no affected_quantity: the backend picks the
 * initial state, and the model has never said HOW MANY pieces broke. S6a pins
 * the absence of both; S7b does not invent either.
 */
import React from "react";

import { normalizeUnit } from "../../../api/adminData";
import { getUnitAddressSubtitle, getUnitHeadingLabel } from "../../../utils/unitDisplayId";
import {
  DIALOG_BTN_PRIMARY,
  DIALOG_BTN_SECONDARY,
  DIALOG_CONTROL,
  DialogActions,
  DialogError,
  DialogField,
  DialogHint,
  InventoryDialog,
} from "./InventoryDialog";

export default function InventoryDamageDialog({
  row,
  unitById,
  form,
  onChangeForm,
  error,
  saving,
  onSubmit,
  onCancel,
}) {
  const u = unitById.get(String(row.unit_id));
  const nu = u ? normalizeUnit(u) : null;

  return (
    <InventoryDialog title="Schaden melden">
      <DialogHint>
        {!nu ? (
          <>Zuordnung · Unit-ID: {row.unit_id}</>
        ) : (
          <>
            {getUnitHeadingLabel(nu)}
            <span className="mt-0.5 block text-[11px] text-muted-foreground">
              {getUnitAddressSubtitle(nu)}
            </span>
            {row.room_name ? (
              <span className="mt-1 block font-medium text-foreground">Room: {row.room_name}</span>
            ) : null}
          </>
        )}
      </DialogHint>
      {error ? <DialogError>{error}</DialogError> : null}
      <form onSubmit={onSubmit} className="mt-4 grid gap-3">
        <DialogField label="Beschreibung *">
          <textarea
            required
            rows={4}
            value={form.description}
            onChange={(e) => onChangeForm((f) => ({ ...f, description: e.target.value }))}
            className={`${DIALOG_CONTROL} resize-y`}
          />
        </DialogField>

        <DialogField label="Geschätzte Kosten (CHF, optional)">
          <input
            type="number"
            step="0.01"
            min="0"
            value={form.estimated_cost_chf}
            onChange={(e) => onChangeForm((f) => ({ ...f, estimated_cost_chf: e.target.value }))}
            className={DIALOG_CONTROL}
          />
        </DialogField>

        <DialogField label="Datum">
          <input
            type="date"
            value={form.reported_at}
            onChange={(e) => onChangeForm((f) => ({ ...f, reported_at: e.target.value }))}
            className={DIALOG_CONTROL}
          />
        </DialogField>

        <DialogActions>
          <button type="button" onClick={onCancel} className={DIALOG_BTN_SECONDARY}>
            Abbrechen
          </button>
          <button type="submit" disabled={saving} className={DIALOG_BTN_PRIMARY}>
            {saving ? "…" : "Schaden melden"}
          </button>
        </DialogActions>
      </form>
    </InventoryDialog>
  );
}
